import axios from "../../utils/axios";

export const getBlogs = async (sortValue, filterValue) => {
    let queryString = "";

    if (sortValue === "newest") {
        queryString += `&_sort=createdAt&_order=desc`;
    } else if (sortValue === "most_liked") {
        queryString += `&_sort=likes&_order=desc`;
    }

    if (filterValue === "saved") {
        queryString += `&isSaved=true`;
    }

    const response = await axios.get(`/blogs/?${queryString}`);

    return response.data;
};
